import "bootstrap/dist/js/bootstrap.bundle";
// import "bootstrap/js/src/index";
import "jquery-match-height";
import "owl.carousel/dist/owl.carousel.min";
import "./_ga";
import "./_facebook";
import "./_twitter";
import "./_linkedin";
import "./modernizr";
import "./_file-uploads";


jQuery(document).ready(function($) {
    
    // ==============================================
    // Drawer Effects
    // ===============================================*/

    let $thisMenu         = $(".navbar-menu.nav--primary");
    let subMenu           = $(".navbar-menu .menu-item .dropdown-menu");
    let $breakpointLarge  = 992;

    // ==============================================
    // Appends the back button to top of sub menus
    // ===============================================*/
    function appendBackButtons(){
      let breakpointLarge   = 992;
      let dropdownMenus     = $(".navbar-menu .menu-item .dropdown-menu");
      let menuBacklinks     = $('.menu--backlink');     
      
      if ($(window).width() < breakpointLarge ) {
        dropdownMenus.each( function(){
            $(this).prepend( $("<li><span class='menu--backlink'>Back</span></li>") );
        })
      }
    }
    appendBackButtons();


    function navigationReset(){
      
      if ($(window).width() > $breakpointLarge ) {
        $thisMenu.removeClass('sub-nav-open');


      }
    }


    // ==============================================
    // Click functionality on back buttons
    // ===============================================*/
    $(document).on('click', '.menu--backlink', function(e){
      
        var $thisSubNav = $(this).parents('ul.dropdown-menu');

        $thisSubNav.removeClass('show');
        $thisSubNav.css('height', 'auto');
        $thisMenu.css('height', 'auto');
      
    })
    
    function drawerNav() {
        let menu            = $(".navbar-menu.nav--primary");
        let subMenu         = $(".navbar-menu .menu-item .dropdown-menu");
        let subMenuItem     = $(".navbar-menu .menu-item a");
        let breakpointSm    = 992;
        
          if ($(window).width() < breakpointSm ) {
              
              subMenuItem.click(function(){
                  var dropdownMenu        = $(this).parent().find("ul");
                  var dropdownMenuHeight  = dropdownMenu.innerHeight();
                  
                  if( dropdownMenuHeight > 0 ){
                    menu.css('height', dropdownMenuHeight );
                    menu.addClass('sub-nav-open');
                  }else{
                    menu.css('height', auto );
                    menu.removeClass('sub-nav-open' );
                  }
              });
          
          }else{
              subMenu.css('height', 'auto' );

              $('.navbar .dropdown').hover(function() {
                  $(this).find('.dropdown-menu').first().stop(true, true).delay(150).slideDown();
              
              }, function() {
                  $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
              
              });
              
              $('.navbar .dropdown > a').click(function(){
                  location.href = this.href;
              });            
          }   
    }

    //Fires Boostrap dropdown bahavior on page load
    drawerNav();

    //Recheck Boostrap dropdown bahavior when window gets resized.
    $(window).bind('resize', function() {
        drawerNav();
    });

    // ==============================================
    // Drawer Navigation Toggle
    // ===============================================*/
    let $drawerNavigation   = $('.navbar--wrapper');
    let $drawerToggle       = $('button.navbar-toggle');
    let $body               = $('body');
    
    $drawerToggle.click( function(){
        $drawerNavigation.toggleClass('open');
        $body.toggleClass('nav-open'); 
    });
    
    $(window).resize(function() {
        if ($drawerNavigation.hasClass('open')){
            $drawerNavigation.removeClass('open'); 
        }
        if ($body.hasClass('nav-open')){
            $body.removeClass('nav-open'); 
        }
    });
    
    $( window ).on('orientationchange', function() {
        if ($drawerNavigation.hasClass('open')){
            $drawerNavigation.removeClass('open'); 
        }
        if ($body.hasClass('nav-open')){
            $body.removeClass('nav-open'); 
        }
    });


    if (window.location.href.indexOf("schedule-service") > -1) {
        $("#choice_2_19_1").prop("checked", true);
        $('#gform_2').addClass('form-schedule-service');
    }else if (window.location.href.indexOf("get-a-quote") > -1) {
        $("#choice_2_19_0").prop("checked", true);
        $('#gform_2').addClass('form-get-a-quote');
    }

$(document).ready(function(){

    $("#certifications-carousel").owlCarousel({
        autoplay: false,
        autoplayTimeout: 7000,
        items:4,
        dots: false,
        nav:true,
        navContainer: ".certifications-slider__nav",
        navText : ["", ""],
        loop:true,
        responsiveClass:true,
        responsive:{
        0 : {
            items:2,
        },
        768 : {
            items:4
        }
    }        
    });

    $("#testimonial-carousel").owlCarousel({
        autoplayTimeout: 7000,
        autoplay: false,
        autoHeight : true,
        items:1,
        nav: true,
        navContainer: ".testimonial-slider__nav",
        navText : ["", ""],
        dots: true,
        loop:true,
        responsiveClass:true
    });

    $("#testimonial-carousel-full-layout").owlCarousel({
      autoplayTimeout: 7000,
      autoplay: false,
      autoHeight : true,
      items:1,
      nav: true,
      navContainer: ".testimonial-slider__nav",
      navText : ["", ""],
      dots: true,
      loop:true,
      responsiveClass:true,
      responsive:{
        0 : {
            items:1,
            slideBy: 1,
        },
        990 : {
            items:3,
            slideBy: 1,
            autoHeight : false,
            dots: true
        }
      }
    });

    $("#journey-carousel").owlCarousel({
        autoplay: false,
        nav: true,
        navContainer: ".journey-slider__nav",
        navText : ["", ""],
        dots: true,
        dotsContainer: ".journey-slider__dots",
        loop:false,
        responsiveClass:true,
        responsive:{
        0 : {
            items:1,
            slideBy: 1,
        },
        990 : {
            items:3,
            slideBy: 3,
            dots: true
        }
    }
    });   

    $("#results-carousel").owlCarousel({
        autoplay: false,
        autoHeight : true,
        items:1,
        nav:true,
        navContainer: ".results-slider__nav",
        navText : ["", ""],
        dots: true,
        mouseDrag: true,
        loop:true
    });
});


  var bigimage = $("#big");
  var thumbs = $("#thumbs");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage
    .owlCarousel({
    items: 1,
    slideSpeed: 6000,
    nav: true,
    autoplay: false,
    dots: false,
    loop: true,
    autoHeight:true,
    responsiveRefreshRate: 200,
    navText : ["", ""],
  })
    .on("changed.owl.carousel", syncPosition);

  thumbs
    .on("initialized.owl.carousel", function() {
    thumbs
      .find(".owl-item")
      .eq(0)
      .addClass("current");
  })
    .owlCarousel({
    items: 4,
    margin: 9,
    dots: false,
    nav: false,
    navText: [
      '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
      '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
    ],
    smartSpeed: 200,
    slideSpeed: 500,
    slideBy: 4,
    responsiveRefreshRate: 100
  })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });


  $(".career-modal-trigger").click(function() {
    let contentID = $(this).attr('data-id');
    contentID = '#content-' + contentID;
    let positionContent = $(contentID).html();
    $('#career-modal .modal-content-wrapper').html(positionContent);

      $("a.scroll-to").click(function() {
        let scrollLocation = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(scrollLocation).offset().top
        }, 1000);
      });

  });

  $("a.scroll-to").click(function() {
    let scrollLocation = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(scrollLocation).offset().top
    }, 2000);
  });



})



// ==============================================
// Navbar docking
// ===============================================*/

jQuery(document).ready(function($){
  
  const NAV = {
    classes : {
        Scrolling : 'scrolling',
        Fixed : 'fixed-top'
    },
    elements : {
        nav : jQuery('#navbar--primary'),
        header : jQuery('#header--site')
    },
    isScrolled : () => {
        let scrolled = false;
        if ($(window).scrollTop() > NAV.elements.header.height()) {
            scrolled = true;
        }
        return scrolled;
    }
  }

  let $siteHeader = $('#header--site');
  let $primaryNav = $('#navbar');


  $(window).on('load scroll', function() {

      let currentOffset = $(window).scrollTop();
      let headerHeight = $siteHeader.height();

      if (NAV.isScrolled()) {
          $primaryNav.addClass(NAV.classes.Scrolling);
      
      }
      
      
      if (currentOffset > headerHeight*2) {
          $primaryNav.addClass('fixed-top');
      }else if (currentOffset < headerHeight ) {
          $primaryNav.removeClass('fixed-top').removeClass('scrolling');
      }
  });

});
